module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedBold.cb91f5d.woff";